import React from 'react';

import LogoPlatForm from 'images/logo-platform.svg';

import useStyles from '../styles';

const HeaderLeftSmartPhone = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapHeaderLeft}>
      <div className={classes.wrapGroupItem}>
        <img
          src={LogoPlatForm}
          className={classes.logoPlatFormSmartPhone}
        />
      </div>
    </div>
  );
};
export default HeaderLeftSmartPhone;
